'use client';
import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const VideoFileView = styled.div`
  border: 1px solid ${colors.secondary.lightGray2};
  /* max-width: 80%; */
  @media (max-width: ${breakPoints.mobile}) {
    max-width: 100%;
  }
`;
